export const BlockedAccessText1 = 'Acesso bloqueado';
export const BlockedAccessText2 = 'por falta de pagamento';
export const PageTextTermsUseText1 = 'clique aqui';
export const PageTextTermsUseText2 = ' para vê-lo.';